<div class="edit-page">
  <div class="visitor">
    <button class="close" (click)="close()">
      <img class="cross-icon" src="icons/profile-close.svg" />
    </button>
    <span class="visitor-txt">Edit Family Code</span>
  </div>

  <p class="form-header">
    Update Family Code of <span class="active">{{data.devoteeFirstName + ' ' + (data.devoteeMiddleName || '') + ' ' +
      data.devoteeLastName}}</span>
  </p>

  <input type="text" maxlength="12" class="text-box-active" placeholder="Enter new family code" [(ngModel)]="fc"
    (input)="getWorkerDetails(fc)" />

  @if(isShow){
  <mat-select [(ngModel)]="selectedMemberCode" placeholder="Select member to update">
    <!-- <mat-option value="fc">N/A</mat-option> -->
    <mat-option *ngFor="let m of philanthropyMembers" [value]="m">
      {{ m.fullName }}
    </mat-option>

  </mat-select>
  <!-- <select
    class="text-box-active"
    aria-placeholder="Select member to update"
    [(ngModel)]="selectedMemberCode"
  >
    <option
      *ngFor="let m of philanthropyMembers"
      [value]="m.memberCode"
    >
      {{ m.fullName }}
    </option>
  </select> -->
  }

  <div class="action-row">
    <button class="ac-secondary-btn" (click)="close()">Cancel</button>
    <button class="primary-btn" (click)="continue()">Continue</button>
  </div>
</div>